export default "__VITE_ASSET__e593c4f5__"